module.exports = __webpack_public_path__ + "static/media/thumbnail.7c55535d.jpg";